<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> SaaS Payments That Scale</div>
            <div class="banner_tips mt-40 fw-300">Payment infrastructure for SaaS platforms. Focus on clients while we handle fast, secure, scalable transactions.</div>
            <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
          </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name  ">Why Corelinkpay for SaaS?</div>
                <div class="title_tag ">Features for seamless payments</div>
            </div>
          <div class="py-20" >
               <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_6 grid_sm_12" v-for="tab in tabList" :key="tab.id">
                    <div class="tab_left text-l border-card p-20 h-100p card_bg">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img :src="tab.icon" alt="" class="">
                        </div>
                        <div class="half_title color1">{{ tab.title }}</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">{{ tab.msg }}</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
      <div class="container pb-80"> 
      <div class="page_top" >
        <div class="page_width" > 
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                  <!-- <div class="flex_col_start"> -->
                    <div class="page_title pb-30">
                      <div class="title_name color1 text-l">Global Reach with Open Banking</div>
                      <div class="title_tag color1 text-l">As a leading payment platform and open banking provider, Corelinkpay connects your SaaS business to major banks across the UK, EU, and beyond. Our solutions offer:</div>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show1?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(1)">Seamless Transactions</div>
                        <el-collapse-transition>
                          <div class="half_text color1 fs-14 fw-300" v-show="show1">Enable instant payments with real-time fund availability.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show2?'active_item':'']">  
                        <div class="half_title fs-30 pointer" @click="showOne(2)">Actionable Insights</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show2">Leverage AI-powered analytics to understand and anticipate client needs.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show3?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(3)">Effortless Integration</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show3">Our user-friendly APIs make it simple to integrate and scale your payment system.</div>
                        </el-collapse-transition>
                    </div>
                    
                  <!-- </div> -->
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t14.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>


    <div class="container page_title_bg page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">FAQs</div>
                <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How quickly can I integrate CorelinkPay’s payment gateway?" name="1">
                            <div class="coll_item">Our streamlined APIs allow you to set up and start processing payments in hours.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is CorelinkPay secure for SaaS transactions?" name="2">
                           <div class="coll_item">Yes, we prioritize security with PCI DSS compliance, encryption, and AI-driven fraud detection.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I support clients in multiple countries?" name="3">
                           <div class="coll_item">Absolutely! CorelinkPay supports multiple currencies and connects with banks worldwide for global reach.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                

            </div>
            </div>
        </div>
    </div>
 

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t44.png" alt="">
                  </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name  text-l">Tools to Transform Your SaaS Business</div>
                        <div class="title_tag  text-l">Experience the power of instant transactions, actionable analytics, and secure payment processing. With CorelinkPay, your SaaS platform can focus on innovation and growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tab1 from '../../assets/image/tb28.png'
import tab2 from '../../assets/image/tb29.png'
import tab3 from '../../assets/image/tb30.png'
import tab4 from '../../assets/image/tb31.png'
import tab5 from '../../assets/image/tb32.png'
import tab6 from '../../assets/image/tb33.png'




export default {
    data(){
        return{
            tabList:[
               
                    {title:"Open Banking Advantage",msg:"Deliver a superior customer experience with secure, streamlined open banking payments.",icon:tab1,id:3},
                    {title:"Effortless Payment Processing",msg:"Simplify pay-ins and pay-outs with intuitive UX, smart routing, and a variety of popular payment methods.",icon:tab2,id:4},
                    {title:"Global Currency Support",msg:"Cater to clients worldwide with multi-currency transactions, making global expansion effortless.",icon:tab3,id:5},
                    {title:"AI-Driven Analytics",msg:"Gain deep insights into client behavior with ready-to-use segmentation and forecasting tools.",icon:tab4,id:6},
                    {title:"Top-Tier Security",msg:"Ensure peace of mind with PCI DSS compliance, advanced encryption, and robust fraud prevention.",icon:tab5,id:7},
                    {title:"Scalable Solutions",msg:"From startups to enterprises, our flexible plans grow with your SaaS business.",icon:tab6,id:8},
              
            ],
         
            activeName:'1',
             show1:true,
            show2:false,
            show3:false,
            show4:false,
        }
    },
      methods:{
      showOne(tab){
      if(this.show1 && tab == 1 || this.show2 && tab == 2 || this.show3 && tab == 3 || this.show4 && tab == 4){
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show4 = false
        return
      }
        switch (tab) {
          case 1:
            this.show1 = true
            this.show2 = false
            this.show3 = false
            this.show4 = false
            break;
          case 2:
            this.show1 = false
            this.show2 = true
            this.show3 = false
            this.show4 = false
            break;
          case 3:
            this.show1 = false
            this.show2 = false
            this.show3 = true
            this.show4 = false
            break;
          case 4:
            this.show1 = false
            this.show2 = false
            this.show3 = false
            this.show4 = true
            break;
          default:
            break;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg6.png);
}

.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.tab_group{
  padding-left:20px;
  position: relative;
  .half_title{
    color:$theme_color1;
     position: relative;
      &::before{
        content: "";
        position: absolute;
        left: -20px;
        top: 18px;
        width: 8px;
        height: 8px;
        border-left: 3px solid #dddddd;
        border-top: 3px solid #dddddd;
        transition: all 0.35s ease-in-out;
        transform: rotate(135deg);
      }
  }
 
}
.active_item{
  .half_title{
      color: $theme_color3;
      position: relative;
      &::before{
        border-left: 3px solid $theme_color3;
        border-top: 3px solid $theme_color3;
        transform: rotate(225deg);
      }
  }
   

}
</style>